import React from "react";

import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Outlet, useLocation, useMatch } from "@tanstack/react-router";

import { BackgroundDecoration } from "@/modules/shared/components/BackgroundDecoration";

import { PAGE_LAYOUTS, type PageLayoutKind } from "../pageLayouts";

const TanStackRouterDevtools =
  process.env.NODE_ENV === "production"
    ? () => null // Render nothing in production
    : React.lazy(() =>
        // Lazy load in development
        import("@tanstack/react-router-devtools").then((res) => ({
          default: res.TanStackRouterDevtools,
          // For Embedded Mode
          // default: res.TanStackRouterDevtoolsPanel
        })),
      );

const getLayoutKind = (pathname: string): PageLayoutKind => {
  if (pathname.startsWith("/embed")) return "embed";
  if (pathname.startsWith("/survey/")) return "survey";
  return "standard";
};

export function RootLayout() {
  const location = useLocation();
  const isDevRoute = useMatch({
    from: "/dev",
    shouldThrow: false,
    select: () => true,
  });

  // The dev shell owns its chrome and renders each preview's layout itself.
  if (isDevRoute) {
    return <Outlet />;
  }

  const kind = getLayoutKind(location.pathname);
  const { Layout, withBackground } = PAGE_LAYOUTS[kind];

  return (
    <>
      {withBackground && <BackgroundDecoration />}
      <Layout />
      <ReactQueryDevtools buttonPosition="top-right" />
      {kind !== "standard" && (
        <TanStackRouterDevtools position="bottom-right" />
      )}
    </>
  );
}
